import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    msg : null
}

export const generalDetailSlice = createSlice({
    name: "general-detail",
    initialState,
    reducers: {
        displayGeneralDetail : (state, action ) => {
            state.msg = action.payload
        },
        cleanGeneralDetail : (state) => {
            state.msg = null
        }
    }
})

export const {
    displayGeneralDetail,
    cleanGeneralDetail
} = generalDetailSlice.actions;

export default generalDetailSlice.reducer;